import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Stack, Typography } from "@mui/material";
import WestIcon from '@mui/icons-material/West';
import InfoIcon from '@mui/icons-material/Info';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, RichHTML } from "@gisce/oficina-virtual-components";
import { useNavigate } from "react-router";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

const LoginEmailSent : FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Stack gap={2} alignItems="flex-start">
      <Typography sx={{fontSize: 32, width: "100%", textAlign: "center"}}>📨</Typography>
      <Typography><RichHTML html={t("common:text.login_email_sent_text")} /></Typography>
      <Accordion variant="outlined">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Stack alignItems="center" direction="row" gap={0.5}>
            <InfoIcon fontSize="small" sx={{mr: 1}}/>
            {t("common:text.login_email_sent_explanation_title")}
          </Stack>
        </AccordionSummary>
        <AccordionDetails sx={{
          pt: "-16px", pb: "-16px"
          }}>
          <RichHTML components={{p: 'span'}} >{t("common:text.login_email_sent_explanation")}</RichHTML>
        </AccordionDetails>
      </Accordion>
      <Button 
        variant="contained" 
        color="primary" 
        startIcon={<WestIcon/>}
        onClick={() => navigate("/")}
      >
        {t("common:text.go_home")}
      </Button>
    </Stack>
  );
};

export default LoginEmailSent ;
